import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, FormGroup, Label,
    Input, Button
} from 'reactstrap';

import { TipoTerceiroContext } from '../../context/TipoTerceiro';
import { UpdateTipoTerceiroType } from '../../context/hooks/useTipoTerceiro';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    tipoTerceiro: UpdateTipoTerceiroType | null;
    onUpdated?: () => void;                     
}

export const EditTipoTerceiroModal: React.FC<Props> = ({
    isOpen,
    toggle,
    tipoTerceiro,
    onUpdated
}) => {
    const { updateTipoTerceiro } = useContext(TipoTerceiroContext);

    const [formData, setFormData] = useState<UpdateTipoTerceiroType | null>(null);

    useEffect(() => {
        if (isOpen) setFormData(tipoTerceiro);
    }, [isOpen, tipoTerceiro]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!formData) return;
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!formData) return;
        const ok = await updateTipoTerceiro(formData);
        if (ok) {
            onUpdated?.();
            toggle();
        }
    };

    if (!formData) return null;

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Editar tipo de terceiro</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label className="form-control-label" htmlFor="type">
                            Tipo do terceiro
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="type"
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                            required
                        />
                    </FormGroup>

                    <div className="d-flex justify-content-end">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">
                            Salvar alterações
                        </Button>
                        <Button
                            style={{ background: '#d9534f', color: '#fff' }}
                            className="ml-2"
                            onClick={toggle}
                        >
                            Cancelar
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default EditTipoTerceiroModal;
